module.exports = __webpack_public_path__ + "static/img/liucheng4@2x.696d6e66.png";